'use strict';

app.service('Documents', function ($q, $preloader, $http, $popup) {

  /**
   * @param doc @param doc {{ name: name, sourceType: 'inline', sourceParams: { instanceId: file.meta.instanceId, fileId : file._id } }}
   * @returns {Promise<result>}
   */
  var saveDoc = function (doc) {
    $preloader.show();
    return $http.post('/api/v1/me/documents', doc)
      .finally($preloader.hide)
      .then(_.property('data'));
  };

  var popup = function (documentNames) {
    if (!_.isArray(documentNames)) {
      documentNames = [documentNames];
    }
    return $popup('doc-save', { documentNames: documentNames});
  };

  /**
   * Save document and display `prompt` popup
   * @param doc
   * @returns {Promise<result>}
   */
  this.save = function (doc) {
    return saveDoc(doc)
      .then(function (result) {
        return popup(result.name)
          .then(_.constant(result));
      });
  };

  /**
   * Alias for Document.save, accepts an array of documents and resolves with array of results
   * @param docs
   * @returns {Promise<[results]>}
   */
  this.saveMultiple = function (docs) {
    return $q.all(_.map(docs, saveDoc))
      .then(function (results) {
        var documentNames = _.map(results, 'name');
        return popup(documentNames)
          .then(_.constant(results));
      });
  };

  /**
   * Remove document
   * @param id
   * @returns {*}
   */
  this.remove = function (id) {
    return $http.delete('/api/v1/me/documents/' + id);
  };
});
